export enum TabStepEnum {
  SHOP_INFO = 'SHOP_INFO',
  CATEGORY = 'CATEGORY',
  PRODUCT = 'PRODUCT',
  RESTAURANT_BUILDER = 'RESTAURANT_BUILDER',
  OLD_USER = 'OLD_USER',
}
